enum ErrorCode {
  ASSIST_DUPLICATE = 100004,
  WRONG_SESSION_OK_TOKEN = 9991,
  NO_ACCESS_TO_FEED = 9992,
  MISSING_PARAMS = 9993,
}

export default ErrorCode;
